import React, { CSSProperties, FormEventHandler, useEffect, useState } from "react";
import logo from "../../media/lo_v_positiv_rgb.png"
import { LabeledInput } from "../LabeledInput/LabeledInput";
import { LabeledTextarea } from "../LabeledTextarea/LabeledTextarea";
import { AutoFilledDateInput } from "../AutoFilledDateInput/AutoFilledDateInput";

export interface FormProps {
    stationName: String|null,
    date: Date,     
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void
};

const FORMSTYLES = {
    display: "flex",
    flexDirection: 'column' as 'column',
    maxWidth: 600,
    width: "80vw",
    gap: 8,
    paddingBottom: "2rem",
}

const TITLEDIV = {
    display: "flex",
    alignItems: "center",
    gap: 16,
    width: 500,
    maxWidth: "80vw",
    overflow: "hidden",
    marginBottom: 16,
}

const TITLESTYLES = {
    fontSize: 22,
    fontFamily: "sans-serif"
}

const LOGOSTYLES = {
    display: "inline-block",
    height: 48,
    width: 48
}

const SBTBTNSTYLES = {
    backgroundColor: "#64a70b",
    margin: "2rem 0 0",
    padding: "1rem 2rem",
    borderRadius: "10px",
    border: "none",
    fontWeight: "bold",
    fontFamily: '"Poppins"',
    color: "#fff",
}

const CHECKBOXSTYLES: CSSProperties = {
    width: 12,
    height: 12,
    marginLeft: 10,
    verticalAlign: 'middle',
    fontSize: 14,
}

const CHECKBOXLABELSTYLES: CSSProperties = {
    fontSize: 14,
}


const Form: React.FC<FormProps> = FormProps => {
    
    const [reportedIssue, setReportedIssue] = useState(true);

    return (
        <>
            <form action="POST" style={FORMSTYLES} onSubmit={FormProps.onSubmit}>
                <div style={TITLEDIV}>
                    <img src={logo} style={LOGOSTYLES} />
                    <h1 style={TITLESTYLES}>Kontroll av Ladestasjon</h1>
                </div>
                <LabeledInput 
                    label={"Stasjonsnavn"}
                    type={"text"}
                    placeholder={FormProps.stationName ?? ""}
                    disabled 
                />
                <LabeledInput 
                    maxLength={3}
                    name="initials"
                    label={"Initialer til kontrollør"}
                    type={"text"}
                />
                <AutoFilledDateInput
                    name="timestamp"
                    label={"Dato"}
                />
                <LabeledTextarea
                    name="comment"
                    maxLength={500}
                    label={"Kommentar (valgfri)"}
                />
                <label style={CHECKBOXLABELSTYLES}>Det er registrert en feil</label>
                <div>
                    <label style={CHECKBOXSTYLES}>Ja</label>
                    <input style={CHECKBOXSTYLES} name="reportedIssue" onChange={() => setReportedIssue(true)} type="radio" value={Number(reportedIssue)} defaultChecked></input>
                    <label style={CHECKBOXSTYLES}>Nei</label>
                    <input style={CHECKBOXSTYLES} name="reportedIssue" onChange={() => setReportedIssue(false)} type="radio" value={Number(reportedIssue)}></input>
                </div>
                <button 
                    type={"submit"}
                    style={SBTBTNSTYLES}
                >Send inn</button>
            </form>
        </>
    )
};

export {
    Form
}